import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

export const StyledSignalWrapper = styled.li`
    padding: 20px 0 13px;
    border-bottom: 1px solid #dedede;

    &:last-child {
        border: none;
    }
`;

export const StyledSignalType = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 2px;
`;

export const StyledSignalTypeIcon = styled(SWReactIcons)`
    margin-right: 5px;
    path {
        fill: ${colorsPalettes.bluegrey[500]};
    }
`;

export const StyledSignalTitleInline = styled.span`
    display: inline;
`;

export const StyledSignalSubType = styled.div`
    ${mixins.setFontVariant("h6", colorsPalettes.bluegrey[500])};
    font-size: 12px;
    font-weight: 400;
`;

export const StyledSignalTitle = styled.div<{ isCapitalized: boolean }>`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon[500])};
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
    &:first-letter {
        text-transform: ${({ isCapitalized }) => (isCapitalized ? "capitalize" : "initial")};
    }
`;

export const StyledSignalDate = styled.div`
    ${mixins.setFontVariant("tab", colorsPalettes.carbon[250])};
    font-weight: 400;
    font-size: 12px;
    margin-right: 4px;
`;

export const StyledSignalFooter = styled.div`
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
`;

export const StyledSignalTag = styled.div`
    margin-left: 4px;
    padding: 0px 8px;
    font-family: ${fonts.$dmSansFontFamily};
    font-weight: 500;
    font-size: 10px;
    line-height: 21px;
    color: ${colorsPalettes.carbon[500]};
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 4px;
`;

export const StyledSignalLinkedInIconWrapper = styled.span`
    display: inline-flex;
    margin: 0 0 0 8px;
    transform: translate(0, 2px);
`;
